import { APP_URLS } from '../../common/settings/urls';
import { APP_ACTIONS } from './appActions';

export const INITIAL_STATE = {
  error: '',
  errorMessage: '',
  isEditing: false,
  isLoading: false,
  formStarted: false,
  formCompleted: false,
  urls: { ...APP_URLS },
  representative: '',
  services: [],
  categories: [],
  servicesRequired: {},
  reasonsRequired: {},
  servicesError: null,
  categoriesError: null,
  codeword: '',
  temporaryLifeChangeEndDate: '',
  postHospitalRecoveryEndDate: '',
  youngHouseholderEndDate: '',
  language: '',
  languages: [],
  languagesError: null,
  autoEnrol: {
    eligible: false,
  },
  additionalRequirements: '',
};

export const appReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP_ACTIONS.UPDATE_FORM_STARTED: {
      return {
        ...state,
        formStarted: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_FORM_COMPLETED: {
      return {
        ...state,
        formCompleted: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_EDITING: {
      return {
        ...state,
        isEditing: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_ERROR_MESSAGE: {
      return {
        ...state,
        errorMessage: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_URLS: {
      return {
        ...state,
        urls: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_REPRESENTATIVE: {
      return {
        ...state,
        representative: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_SERVICES: {
      return {
        ...state,
        services: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_CATEGORIES: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_SERVICES_REQUIRED: {
      return {
        ...state,
        servicesRequired: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_REASONS_REQUIRED: {
      return {
        ...state,
        reasonsRequired: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_SERVICES_ERROR: {
      return {
        ...state,
        servicesError: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_CATEGORIES_ERROR: {
      return {
        ...state,
        categoriesError: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_CODE_WORD: {
      return {
        ...state,
        codeword: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_TEMPORARY_LIFE_CHANGE_END_DATE: {
      return {
        ...state,
        temporaryLifeChangeEndDate: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_POST_HOSPITAL_RECOVERY_END_DATE: {
      return {
        ...state,
        postHospitalRecoveryEndDate: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_YOUNG_HOUSE_HOLDER_END_DATE: {
      return {
        ...state,
        youngHouseholderEndDate: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_LANGUAGE: {
      return {
        ...state,
        language: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_LANGUAGES: {
      return {
        ...state,
        languages: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_LANGUAGES_ERROR: {
      return {
        ...state,
        languagesError: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_AUTO_ENROL: {
      return {
        ...state,
        autoEnrol: action.payload,
      };
    }
    case APP_ACTIONS.UPDATE_ADDITIONAL_REQUIREMENTS: {
      return {
        ...state,
        additionalRequirements: action.payload,
      };
    }
    case APP_ACTIONS.RESET_APP: {
      return {
        ...INITIAL_STATE,
      };
    }
    default:
      return state;
  }
};
